const setGender = (gender) => {
  if (!gender) return "";

  switch (gender) {
    case "M":
      return "1";
    case "F":
      return "2";
  }
};

export const getOcrData = (data) => {
  return {
    imageContainer: data?.imageContainer || "",
    imageLocation: data?.imageLocation || "",
    lastName: data?.lastName || "",
    firstName1: data?.firstName1 || "",
    firstName2: data?.firstName2 || "",
    idType: data?.idType || "",
    idSeries: data?.idSeries || "",
    idNumber: data?.idNumber || "",
    dateOfIssue: data?.dateOfIssue || "",
    expiryDate: data?.expiryDate || "",
    dateOfBirth: data?.dateOfBirth || "",
    nationality: data?.nationalityId?.toString() || "",
    cnp: data?.cnp || "",
    gender: setGender(data?.gender),
    streetType: data?.streetTypeId?.toString() || "",
    streetName: data?.streetName || "",
    streetNumber: data?.streetNumber || "",
    buildingNo: data?.buildingNumber || "",
    entranceNumber: data?.entranceNumber || "",
    apartmentNumber: data?.apartmentNumber || "",
    county: data?.countyCode || "",
    localityName: data?.localityName || "",
    localityType: data?.localityType || "",
    uatType: data?.uatType || "",
    uatName: data?.uatName || "",
    etaj: data?.floorNumber || "",
    placeOfBirth: data?.placeOfBirth || "",
  };
};
